export default __webpack_public_path__ + "static/media/Menu_gd.2a9afbcc.svg";